import { withRouter } from 'react-router-dom';

import { useAppAlert } from '@Components/AppAlert';
import FormWrapper from '@Components/form/Wrapper';
import history from 'utils/history';

import Form from '../components/Form';
import Heading from '../components/Heading';
import { SnippetProvider, useSnippetStore } from '../store';

const SnippetForm = withRouter(({ match: { params: { id } } }) => {
  const { collection: { item, useLoad, useSubmit } } = useSnippetStore()
  const { handleSuccess, handleError } = useAppAlert()

  useLoad(id)
  const handleSubmit = useSubmit()

  const handleSubmitAndClose = async payload => {
    try {
      await handleSubmit(payload)
      const message = payload.id ? 'edited' : 'created'
      history.push(`/cms/snippets`);
      handleSuccess('Success', `Snippet ${message}.`)
    } catch {
      handleError('Error', 'Snippet was not saved.')
    }
    history.push(`/cms/snippets`);
  }

  if (!item) {
    return null
  }

  return <>
    <FormWrapper title="Snippet">
      <Heading data={item} />
      <Form data={item} handleSubmit={handleSubmitAndClose} />
    </FormWrapper>
  </>
});

export default function SnippetFormLayout() {
  return <SnippetProvider>
    <SnippetForm />
  </SnippetProvider>
}
